/**
 * Cliente HTTP de auth contra o backend do CX Monitor.
 *
 * O CX expõe:
 *   POST /auth/login     { email, password } → { access_token, ... }
 *   POST /auth/refresh   {} → { access_token }
 *   GET  /auth/me        → { sub, role, ... }
 */

const AUTH_BASE = import.meta.env.PROD
  ? 'https://cx.stage.surf.com.br'
  : ''; // proxy do vite em dev

interface LoginResponse {
  access_token: string;
  token_type: string;
  refresh_token?: string;
}

export async function login(
  email: string,
  password: string,
): Promise<LoginResponse> {
  const res = await fetch(`${AUTH_BASE}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });

  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    throw new Error(`Login falhou (HTTP ${res.status}): ${detail}`);
  }

  return res.json();
}

export async function logout(jwt: string): Promise<void> {
  await fetch(`${AUTH_BASE}/auth/logout`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${jwt}` },
  }).catch(() => {
    // Logout server-side é best-effort
  });
}
